import { forEach, isArray } from 'lodash';

import { InventorySearchEvents } from '../events';
import { findOptions } from './helpers';
import Slider from './Slider';
import Dropdown from './Dropdown';
import Inputs from './Inputs';
import Checkboxes from './Checkboxes';
import Custom from './Custom';

/**
 * Handles Filter creation
 * @param {HTMLElement} container   filter container
 * @param {Function} updateCallback callback function called when filter parameters change
 * @param {Object} searchParameters object of search parameters, ex. {make: 'Ford', year_min: '2010'}
 * @param {Object} data             inventory
 * @param {Object} selected         object of filters set up in WP Custom Filters
 */
export class DSPFilter {
  constructor(container, updateCallback, searchParameters, data, selected) {
    this.container = container;
    this.type = container.getAttribute('data-type');
    this.searchParameter = container.dataset.searchParameter ?? container.id;
    this.containerId = container.id;
    this.updateCallback = updateCallback;
    this.data = data;
    this.options = findOptions(this.container, this.searchParameter, this.data);
    this.searchParameters = searchParameters;
    this.selected = selected;
  }

  create() {
    // if custom filters are set in WP, take filter params from
    // these filters and add them to search parameters object
    if (this.selected) {
      forEach(this.selected, (value, param) => {
        if (!param.includes(this.searchParameter)) {
          return;
        }

        if (isArray(value)) {
          this.searchParameters[this.searchParameter] = value.join(',') + ',';
        } else {
          this.searchParameters[param] = value;
        }
      });
    }

    this.container.dispatchEvent(
      new CustomEvent(InventorySearchEvents.PRE_SEARCH_FILTER_UPDATE, {
        bubbles: true,
        detail: { filter: this },
      }),
    );

    let filter;
    switch (this.type) {
      case 'slider':
        let sliderOptions = {
          start: [this.options.minValue, this.options.maxValue],
          step: this.options.step,
          behaviour: 'drag',
          connect: true,
          range: {
            min: [this.options.minValue],
            max: [this.options.maxValue],
          },
        };

        filter = new Slider(
          this.containerId,
          this.searchParameter,
          sliderOptions,
          this.updateCallback,
          this.searchParameters,
        );
        break;

      case 'checkboxes':
        filter = new Checkboxes(
          this.containerId,
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters,
        );
        break;

      case 'inputs':
        filter = new Inputs(
          this.containerId,
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters,
        );
        break;

      case 'dropdown':
        filter = new Dropdown(
          this.containerId,
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters,
        );
        break;

      case 'custom':
        filter = new Custom(
          this.containerId,
          this.searchParameter,
          this.options,
          this.updateCallback,
          this.searchParameters,
        );
        break;

      default:
        console.warn(`Unknown filter type: ${this.type}`, { filter: this });
        return;
    }

    filter.create();
    filter.update();

    this.container.dispatchEvent(
      new CustomEvent(InventorySearchEvents.POST_SEARCH_FILTER_UPDATE, {
        bubbles: true,
        detail: { filter: this },
      }),
    );
  }
}
